export default __webpack_public_path__ + "static/VerifiedDestination-320c062b7c1db52846b9782e11ee137b.png";